import { hexToHSL } from '@trello/colors';
import {
  IconDefaultColor,
  IconLightColor,
  TextDefaultColor,
  TextLightColor,
} from '@trello/nachos/tokens';
import type {
  BackgroundBrightness,
  DynamicVariables,
} from './BoardTheme.types';

const TEXT_TRANSPARENCY = 0.16;

/**
 * Given a background brightness, derive a dynamic text and icon color set.
 * Extracted from useBoardBackground for usage outside of React.
 */
export const getDynamicTextColor = (
  backgroundBrightness: BackgroundBrightness,
): Pick<
  DynamicVariables,
  'dynamicIconColor' | 'dynamicTextColor' | 'dynamicTextColorTransparent'
> => {
  let dynamicIconColor = IconDefaultColor;
  let dynamicTextColor = TextDefaultColor;

  if (backgroundBrightness === 'dark') {
    dynamicIconColor = IconLightColor;
    dynamicTextColor = TextLightColor;
  }

  return {
    dynamicIconColor,
    dynamicTextColor,
    dynamicTextColorTransparent: hexToHSL(dynamicTextColor, TEXT_TRANSPARENCY),
  };
};
